<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card card-custom card-stretch gutter-b" id="page">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">
              Détail du client
            </h3>
            <div class="card-toolbar">
              <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                  no-caret
                  right
                  no-flip
                >
                  <template v-slot:button-content>
                    <i class="ki ki-bold-more-ver"></i>
                  </template>
                  <!--begin::Navigation-->
                  <div class="navi navi-hover" style="width: 250px">
                    <b-dropdown-text
                      tag="div"
                      class="navi-item"
                      @click="goToMessages(client.userId)"
                    >
                      <a href="javascript:;" class="navi-link">
                        <span class="navi-icon">
                          <i class="fas fa-comments"></i>
                        </span>
                        <span class="navi-text">Messages</span>
                      </a>
                    </b-dropdown-text>

                

        
                  </div>
                  <!--end::Navigation-->
                </b-dropdown>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-xl-6">
                <div class="d-flex flex-wrap align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Client:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <span
                        class="text-dark-75 font-weight-bolder font-size-h6"
                        >{{ client.fullName }}</span
                      >
                    </div>
                  </div>
                  <!--end::Info-->
                </div>
                <div class="separator separator-dashed mt-2 mb-2"></div>
                <div class="d-flex flex-wrap align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Téléphone:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <span
                        class="text-dark-75 font-weight-bolder font-size-h6"
                        >{{ client.phoneNumber }}</span
                      >
                    </div>
                  </div>
                  <!--end::Info-->
                </div>
                <div class="separator separator-dashed mt-2 mb-2"></div>
                <div class="d-flex flex-wrap align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Adresse:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <span
                        class="text-dark-75 font-weight-bolder font-size-h6"
                        >{{ client.address }}</span
                      >
                    </div>
                  </div>
                  <!--end::Info-->
                </div>
              </div>
              <div class="col-xl-6">
                <div class="d-flex flex-wrap align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Email:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <span
                        class="text-dark-75 font-weight-bolder font-size-h6"
                      >
                        {{ client.email }}
                      </span>
                    </div>
                  </div>
                  <!--end::Info-->
                </div>
                 <div class="separator separator-dashed mt-2 mb-2"></div>
                <div class="d-flex flex-wrap align-items-center">
                  <!--begin::Symbol-->
                  <div
                    class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4"
                  ></div>
                  <!--end::Symbol-->
                  <!--begin::Title-->
                  <div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">
                    <div class="text-dark-75 font-weight-bolder font-size-lg">
                      Code postal:
                    </div>
                  </div>
                  <!--end::Title-->
                  <!--begin::Info-->
                  <div class="d-flex align-items-center py-lg-0 py-2">
                    <div class="d-flex flex-column text-right">
                      <span
                        class="text-dark-75 font-weight-bolder font-size-h6"
                      >
                        {{ client.postalCode }}
                      </span>
                    </div>
                  </div>
                  <!--end::Info-->
                </div>

               
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.image {
  max-height: 300px;
  max-width: 300px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SELECT_NOTIFICATION } from "../../../core/services/store/notification.module";

import clientsService from "../../../services/clients.service";

//import SearchApiService from "../../../core/services/searchapi.service";
//import JwtService from "../../../core/services/jwt.service";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "detail",
  components: {},
  data() {
    return {
      client: {},
    };
  },
  validations: {
    quote: {
      amount: {
        required,
      },
    },
    cancel: {
      motiveGuid: {
        required,
      },
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getClient(to.params.guid);
    next();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Patients" },
      { title: "Detail" },
    ]);
    this.$store.dispatch(SELECT_NOTIFICATION, this.$route.params.guid);

    this.getClient(this.$route.params.guid);
  },
  methods: {
    getClient: function (guid) {
      clientsService.getClient(guid).then((result) => {
        this.client = result.data;
      });
    },
    goToMessages(guid) {
      this.$router.push({
        name: "clients-messages-detail",
        params: { guid: guid },
      });
    },
    goToResults(guid) {
      this.$router.push({
        name: "clients-results",
        params: { guid: guid },
      });
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
